
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/reviews",
      function () {
        return require("private-next-pages/[region]/[resort]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/reviews"])
      });
    }
  